/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".fee-section-summary__disclaimers[_ngcontent-%COMP%]{font-size:13px;color:#666}"];
export { styles as styles };
